const locales = {
  'en-US': {
    vstFormat: 'en',
    direction: 'ltr',
    rfc: 'en-US',
  },
  'ar-SA': {
    vstFormat: 'ar',
    direction: 'rtl',
    rfc: 'ar-SA',
  },
  'bg-BG': {
    vstFormat: 'bg',
    direction: 'ltr',
    rfc: 'bg-BG',
  },
  'ca-ES': {
    vstFormat: 'ca',
    direction: 'ltr',
    rfc: 'ca-ES',
  },
  'cs-CZ': {
    vstFormat: 'cs',
    direction: 'ltr',
    rfc: 'cs-CZ',
  },
  'cy-GB': {
    vstFormat: 'cy',
    direction: 'ltr',
    rfc: 'cy-GB',
  },
  'da-DK': {
    vstFormat: 'da',
    direction: 'ltr',
    rfc: 'da-DK',
  },
  'de-DE': {
    vstFormat: 'de',
    direction: 'ltr',
    rfc: 'de-DE',
  },
  'el-GR': {
    vstFormat: 'el',
    direction: 'ltr',
    rfc: 'el-GR',
  },
  'en-GB': {
    vstFormat: 'en_GB',
    direction: 'ltr',
    rfc: 'en-GB',
  },
  'es-ES': {
    vstFormat: 'es',
    direction: 'ltr',
    rfc: 'es-ES',
  },
  'es-MX': {
    vstFormat: 'es_MX',
    direction: 'ltr',
    rfc: 'es-MX',
  },
  'es-419': {
    vstFormat: 'es_419',
    direction: 'ltr',
    rfc: 'es-419',
  },
  'fr-CA': {
    vstFormat: 'fr_CA',
    direction: 'ltr',
    rfc: 'fr-CA',
  },
  'fr-FR': {
    vstFormat: 'fr',
    direction: 'ltr',
    rfc: 'fr-FR',
  },
  'ga-IE': {
    vstFormat: 'ga',
    direction: 'ltr',
    rfc: 'ga-IE',
  },
  'he-IL': {
    vstFormat: 'he',
    direction: 'rtl',
    rfc: 'he-IL',
  },
  'hi-IN': {
    vstFormat: 'hi',
    direction: 'ltr',
    rfc: 'hi-IN',
  },
  'is-IS': {
    vstFormat: 'is',
    direction: 'ltr',
    rfc: 'is-IS',
  },
  'it-IT': {
    vstFormat: 'it',
    direction: 'ltr',
    rfc: 'it-IT',
  },
  'ja-JP': {
    vstFormat: 'ja',
    direction: 'ltr',
    rfc: 'ja-JP',
  },
  'ko-KR': {
    vstFormat: 'ko',
    direction: 'ltr',
    rfc: 'ko-KR',
  },
  'hu-HU': {
    vstFormat: 'hu',
    direction: 'ltr',
    rfc: 'hu-HU',
  },
  'nl-NL': {
    vstFormat: 'nl',
    direction: 'ltr',
    rfc: 'nl-NL',
  },
  'nb-NO': {
    vstFormat: 'no',
    direction: 'ltr',
    rfc: 'nb-NO',
  },
  'pl-PL': {
    vstFormat: 'pl',
    direction: 'ltr',
    rfc: 'pl-PL',
  },
  'pt-BR': {
    vstFormat: 'pt_BR',
    direction: 'ltr',
    rfc: 'pt-BR',
  },
  'pt-PT': {
    vstFormat: 'pt',
    direction: 'ltr',
    rfc: 'pt-PT',
  },
  'ru-RU': {
    vstFormat: 'ru',
    direction: 'ltr',
    rfc: 'ru-RU',
  },
  'ro-RO': {
    vstFormat: 'ro',
    direction: 'ltr',
    rfc: 'ro-RO',
  },
  'fi-FI': {
    vstFormat: 'fi',
    direction: 'ltr',
    rfc: 'fi-FI',
  },
  'sv-SE': {
    vstFormat: 'sv',
    direction: 'ltr',
    rfc: 'sv-SE',
  },
  'tl-PH': {
    vstFormat: 'fil',
    direction: 'ltr',
    rfc: 'tl-PH',
  },
  'th-TH': {
    vstFormat: 'th',
    direction: 'ltr',
    rfc: 'th-TH',
  },
  'vi-VN': {
    vstFormat: 'vi',
    direction: 'ltr',
    rfc: 'vi-VN',
  },
  'tr-TR': {
    vstFormat: 'tr',
    direction: 'ltr',
    rfc: 'tr-TR',
  },
  'zh-CN': {
    vstFormat: 'zh_CN',
    direction: 'ltr',
    rfc: 'zh-CN',
  },
  'zh-TW': {
    vstFormat: 'zh_TW',
    direction: 'ltr',
    rfc: 'zh-TW',
  },
};

const languageToLocale = {
  en: 'en-US',
  ar: 'ar-SA',
  bg: 'bg-BG',
  ca: 'ca-ES',
  cs: 'cs-CZ',
  cy: 'cy-GB',
  da: 'da-DK',
  de: 'de-DE',
  el: 'el-GR',
  es: 'es-ES',
  fr: 'fr-FR',
  ga: 'ga-IE',
  he: 'he-IL',
  hi: 'hi-IN',
  is: 'is-IS',
  it: 'it-IT',
  ja: 'ja-JP',
  ko: 'ko-KR',
  hu: 'hu-HU',
  nl: 'nl-NL',
  nb: 'nb-NO',
  pl: 'pl-PL',
  pt: 'pt-PT',
  ru: 'ru-RU',
  ro: 'ro-RO',
  fi: 'fi-FI',
  sv: 'sv-SE',
  tl: 'tl-PH',
  th: 'th-TH',
  vi: 'vi-VN',
  tr: 'tr-TR',
  zh: 'zh-CN',
};

const localeMap = {
  'es-LA': 'es-419',
  'es-AR': 'es-419',
  'es-BO': 'es-419',
  'es-CL': 'es-419',
  'es-CO': 'es-419',
  'es-CR': 'es-419',
  'es-CU': 'es-419',
  'es-DO': 'es-419',
  'es-EC': 'es-419',
  'es-SV': 'es-419',
  'es-GT': 'es-419',
  'es-HN': 'es-419',
  'es-NI': 'es-419',
  'es-PA': 'es-419',
  'es-PY': 'es-419',
  'es-PE': 'es-419',
  'es-PR': 'es-419',
  'es-US': 'es-419',
  'es-UY': 'es-419',
  'es-VE': 'es-419',
};

const getLocale = (localeString) => {
  if (!localeString) {
    return undefined;
  }

  const [language, region] = localeString.toLocaleLowerCase().split(/-|_/gi);
  const normalizedLocaleString = region ? `${language}-${region}` : '';

  const findLocale = (target) => 
    Object.entries(target).find(([key]) => key.toLocaleLowerCase() === normalizedLocaleString);

  const fullLocaleKey = findLocale(locales);
  if (fullLocaleKey) {
    return fullLocaleKey[1];
  }

  const localeMapKey = findLocale(localeMap);
  if (localeMapKey) {
    return locales[localeMapKey[1]];
  }

  return locales[languageToLocale[language]] || locales[languageToLocale['en']];
};

export default getLocale;


  